export default "__VITE_ASSET__6V7IUAPm__"